export default __webpack_public_path__ + "static/media/SV.f33a701d.svg";